module.exports = __webpack_public_path__ + "img/LetzterAbend.a944d4e1.svg";